import {WorkrequestLndWDetails} from './workrequest-lnd-w-details';
import {WorkrequestLndBaseViewmodel} from './workrequest-lnd-base-viewmodel';

export class WorkrequestLndWViewmodel extends WorkrequestLndBaseViewmodel {
  within1To10LotsAmount: number;
  greaterThan10LotsAmount: number;

  constructor() {
    super();
    this.within1To10LotsAmount = 0;
    this.greaterThan10LotsAmount = 0;
    this.workrequestDetails = new WorkrequestLndWDetails();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-w-form/workrequest-lnd-w-viewmodel.ts